(function () {
  function findElements(id) {
    var btn = document.getElementById("support-widget-btn-" + id);
    var modalBg = document.getElementById("support-widget-modal-bg-" + id);
    var closeBtn = document.getElementById("support-widget-close-" + id);
    return { btn: btn, modalBg: modalBg, closeBtn: closeBtn };
  }

  function bindForId(id) {
    var els = findElements(id);
    if (!els.btn || !els.modalBg || !els.closeBtn) return;

    // Only bind modal behavior when explicitly flagged
    if (els.btn.hasAttribute("data-open-modal")) {
      els.btn.addEventListener("click", function (e) {
        els.modalBg.classList.add("active");
        els.modalBg.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
      });
    }

    els.closeBtn.addEventListener("click", function () {
      els.modalBg.classList.remove("active");
      els.modalBg.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    });

    els.modalBg.addEventListener("click", function (e) {
      if (e.target === els.modalBg) {
        els.modalBg.classList.remove("active");
        els.modalBg.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && els.modalBg.classList.contains("active")) {
        els.modalBg.classList.remove("active");
        els.modalBg.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      }
    });
  }

  // Initialize for any widgets present on the page
  document
    .querySelectorAll(".support-widget-btn[data-widget-id]")
    .forEach(function (node) {
      bindForId(node.getAttribute("data-widget-id"));
    });
})();
